import axios from 'axios'
// import api from './api'
// 4.ES6 Promise || ES7 async/await 封装方式
export default function request(options) {

  // 1.将 Promise 方法返回出去
  return new Promise((resolve, reject) => {
    // 2.使用 axios 的实例对象
    let instance = axios.create({
      // baseURL: api.interim, // 默认路径
      timeout: 50000 // 请求时间
    })

    // 过滤器
    instance.interceptors.response.use(res => {
      // 在这里判断 token 是否过期
      return res.data
    }, err => {
      console.log('来到了 response 拦截 failure 中');
      console.error(err);
      if (err && err.response) {
        switch (err) {
          case 400:
            err.message = '请求错误'
            break
          case 401:
            err.message = '未授权的访问'
            break
          case 403:
            err.message = '拒绝访问'
            break
          case 404:
            err.message = `请求地址出错: ${response.config.url}`
            break
          case 408:
            err.message = '请求超时'
            break
          case 500:
            err.message = '服务器内部错误'
            break
          case 501:
            err.message = '服务未实现'
            break
          case 502:
            err.message = '网关错误'
            break
          case 503:
            err.message = '服务不可用'
            break
          case 504:
            err.message = '网关超时'
            break
          case 505:
            err.message = 'HTTP版本不受支持'
            break
          default:
        }
      }
      return err
    })

    // 3.通过实例发送网络请求
    instance(options).then(res => {
      // console.log(res, '_____')
      resolve(res)
    }).catch(err => {
      // console.log(err, 'err_____')
      reject(err)
    })
  })
}